import BaseUseCase from "../../base_use_case.js";

class LoadProjectsListUseCase extends BaseUseCase {
  
  execute(params) {
    return this.httpClient({
      ...this.requestConfig(),
      method: "get",
      url: `/api/v1/projects/projects`,
      params: params
    }).then((result) => {
      return result
    })
  }
}

const instance = new LoadProjectsListUseCase();
export default instance;